import { cn } from '@rental/ui'
import type { ReactNode } from 'react'

/**
 * One subject on one pane of glass (DESIGN.md, "Glass: five surfaces"): its
 * heading, a status beside it, and what it holds. Not a landmark: a screen of
 * panes would be a screen of regions. A part inside it that its heading
 * names, such as the Planning's days under their category, takes the
 * heading's id (`headingId`). What is done to the subject as a whole (S8:
 * "Modifica dati") stands at the end of the heading's row, as a screen's own
 * actions do in its header.
 */
export function Section({
  title,
  status,
  actions,
  headingId,
  children,
  className,
}: {
  title: ReactNode
  status?: ReactNode
  actions?: ReactNode
  headingId?: string
  children: ReactNode
  className?: string
}) {
  return (
    <section className={cn('glass-pane flex flex-col gap-3 rounded-card p-4 sm:p-6', className)}>
      <div className="flex flex-wrap items-center gap-2">
        <h2 id={headingId} className="text-xl">
          {title}
        </h2>
        {status}
        {actions ? (
          <div className="ms-auto flex flex-wrap items-center gap-3">{actions}</div>
        ) : null}
      </div>
      {children}
    </section>
  )
}
